import type { LangCode } from "@/lib/gql/__generated__/graphql";

import type { ProductRoomI18nFormModel } from "../type";

type Props = {
	hotelID: string;
	roomID: string;
	lang: LangCode;
	queryData: ProductRoomI18nFormModel["QueryData"];
};

export const DEFAULT_PRODUCT_ROOM_I18N_INPUT_MODEL = ({ hotelID, roomID, lang }: Props) => {
	const inputModel: ProductRoomI18nFormModel["InputModel"] = {
		hotelID,
		roomID,
		lang,

		name: "",

		address: {
			city: "",
			nationality: "",
			other: "",
			postalCode: "",
			pref: "",
			state: "",
			town: "",
		},
		catchCopy: "",
		description: "",
	} satisfies ProductRoomI18nFormModel["InputModel"];

	return inputModel;
};
